export var ComponentFlag;
(function (ComponentFlag) {
    ComponentFlag["New"] = "New";
    ComponentFlag["Deprecated"] = "Deprecated";
})(ComponentFlag || (ComponentFlag = {}));
